import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Topnav from "../../components/adminNav/Topnav";
import Sidebar from "../../components/sidebar/Sidebar";
import { BASE_URL } from "../../requestMethod";
import { css } from "@emotion/react";
import ClipLoader from "react-spinners/ClipLoader";
import "./product.css"

const Product = () => {

    const user = useSelector((state) => state.user.currentUser);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false)
    let [color, setColor] = useState("#ffffff");
    
    const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

    useEffect(() => {
        const getProducts = async () => {
            try {
                const res = await axios.get(`${BASE_URL}Product/vendorproducts?vendorId=${user.returnObj.vendorId}`, {
                    mode: 'no-cors',
                    headers: { 'Authorization': `Bearer ${user.returnObj.token}` }
                })
                //console.log(res.data.returnObj);
                setProducts(res.data.returnObj);
            }
            catch (err) {
                console.log(err)
            }
        }
        getProducts();
    }, []);

    const deleteProduct = async (id) => {
        //Product?Id=43dfe065-25bf-46a2-7911-08d9dcbc3029
        console.log(id);
        try {
            const res = await axios.get(`${BASE_URL}Product/delete?Id=${id}`, {
                mode: 'no-cors',
                headers: { 'Authorization': `Bearer ${user.returnObj.token}` }
            })
            console.log(res.data.returnObj);
            if (res.data.status) {
                Swal.fire({
                    title: 'Success',
                    text: res.data.response,
                    icon: 'success',
                    confirmButtonText: 'Thanks'
                });
                //toast.success(res.data.response)
                window.location.replace("/products");
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.response,
                    icon: 'error',
                    confirmButtonText: 'Cancel'
                });
            }
        }
        catch (err) {
            console.log(err)
        }
    }
    return (

        <div className="container-scroller">
            <Topnav />
            <div className="container-fluid page-body-wrapper">
                <Sidebar />
                <div className="content-wrapper">
                    <div className="row">
                        <div className="col-12 grid-margin">
                            <div className="card">
                                
                                <div className="card-body">
                                    <div className="page-header flex-wrap w-100 ">
                                        <h3 className="page-title"> Products </h3>
                                        <nav aria-label="breadcrumb">
                                            <ol className="breadcrumb">
                                                <li className="breadcrumb-item"><a href="/createProduct"><button type="button" className=" text-decoration-none default-btn btn-gradient-success bg-success ">Add Product</button> </a></li>
                                            </ol>
                                        </nav>      
                                    </div>
                                    <h4 className="card-title">All Availible Products</h4>
                                    {loading && (<p style={{color:'green',textAlign:'center'}}>Loading...</p>)}
                                    <div className="table-responsive">
                                        <table className="table mb-5">
                                            <thead>
                                                <tr>
                                                    <th> Image </th>
                                                    <th> Product Name </th>
                                                    <th> Minimum Price </th>
                                                    <th> Season </th>
                                                    <th> Action </th>
                                                </tr>
                                            </thead>
                                            {products ? (
                                                <tbody>
                                                    
                                                    {products.map((item) => (
                                                        <tr key={item.id}>
                                                            <td>
                                                                <img src={item.imageUrl} className="me-2" alt="image" />
                                                            </td>
                                                            <td> {item.name} </td>
                                                            <td>
                                                                {item.minimumPrice}
                                                            </td>
                                                            <td>
                                                                {item.inSeason}
                                                            </td>
                                                            <td>
                                                                <div className="btn-group">
                                                                    <button type="button" className="default-btn btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="true">Action</button>
                                                                    <div className="dropdown-menu" style={{ position: 'absolute', inset: '0px auto auto 0px', margin: '0px', transform: 'translate(0px, 46px)' }} data-popper-placement="bottom-start">
                                                                        <a className="dropdown-item">Deactivate</a>
                                                                        <Link to={`/edit-product/${item.id}`}> <div className="dropdown-item  ">Edit</div></Link>
                                                                        <a className="dropdown-item" onClick={() => deleteProduct(item.id)}>Delete</a>
                                                                    </div>
                                                                </div>

                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            ) : (
                                                <p>No product Yet!</p>
                                            )}

                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}


export default Product;